import { render, staticRenderFns } from "./CompanyLog.vue?vue&type=template&id=0f22f825&"
import script from "./CompanyLog.vue?vue&type=script&lang=js&"
export * from "./CompanyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports